export const environment = {
  production: false,
  versionCheckURL: 'version.json',
  env: 'test',
  quickPayUrl: 'https://ways2pay-st.apps.nwie.net',
  quickPayClientId: '7I1M4s7YG26kJu23VGobaQVDglPYd8lX',

  encryptionKey:'hz24HaES1Z5iCbhgTLY0VVNw13gymbM2',

  hosts:{
    api:'https://apipci-int-test.nwie.net',
    token:'https://api.identity-test.nwie.net'
  },
  endpoints:{
    authenticate:'/underwriting-management/life-premium-portal-auth/v1/authenticate',
    token:'/information-risk-management/enterprise-user-auth/v3/token',
    userDetails:'/underwriting-management/life-premium-portal-auth/v1/account-details?includeBalance=true',
    paymentRequest:'/underwriting-management/life-premium-portal-auth/v1/payments',
    recurringPayment:'/underwriting-management/life-premium-portal-auth/v1/policies/billing-options'
  },
  clientID: '7I1M4s7YG26kJu23VGobaQVDglPYd8lX',

  splunk: {
    token: 'dcba5726-8f78-4efd-87f5-89cfadbca198',
    endpoint: 'https://api-test.nwie.net/it-management/client-logging/v1/client-logs',
    environment: 'DEV'
  },
};
